/**
 *
 * TripTypeBadge
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { COLORS } from 'theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.blueDark};
    background: ${COLORS.blueLight};
    border-color: ${COLORS.blue};
  }
`;

function TripTypeBadge({ label, ...props }) {
  return <StyledBadge label={label} {...props} />;
}

TripTypeBadge.propTypes = {
  label: PropTypes.string.isRequired,
};

export default memo(TripTypeBadge);
